import styled from "styled-components";

let S = {};

S.Container = styled.div`
	&.invisible {
		visibility: hidden;
	}

	& label {
		display: block;
		cursor: pointer;
		font-size: 0.95rem;
		padding-bottom: 3.5px;
		margin-bottom: 0;
	}

	& label > span {
		display: inline;
		padding: 0;
	}

	& label > span.error {
		color: var(--error);
	}

	& textarea {
		width: 100%;
		border: 1px solid var(--border);
		border-radius: 2px;
		padding: 5.5px 7.5px;
		box-shadow: var(--boxshadow);
		-webkit-transition: box-shadow 150ms ease;
		transition: box-shadow 150ms ease;
		font-family: inherit;
		font-size: 16px;
		line-height: 25px;
		outline: none;
		height: 100px;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;

		&:focus {
			border-color: var(--primary);
		}

		&.error {
			border-color: var(--error);
		}
	}
`;

export default S;
